<template>
  <div class="flex flex-col gap-2 p-4">
    <div class="font-medium uppercase">
      <FontAwesomeIcon :icon="faTimesCircle" />
      {{ $t('components.projects.statusTaskControl.awaitingSolution.title') }}
    </div>

    <p
      v-if="currentUser.roles.includes('admin:skyloud')"
      class="text-sm"
    >
      {{ $t('components.projects.statusTaskControl.awaitingSolution.clientRefused') }} ⛔️
    </p>
    <div v-else>
      <p class="text-sm">{{ $t('components.projects.statusTaskControl.awaitingSolution.estimationRefused') }}</p>
      <p class="mt-2 text-sm">{{ $t('components.projects.statusTaskControl.awaitingSolution.taskArchivedSoon') }}</p>
    </div>
    <WaitingButtonsControl
      v-if="currentUser.roles.includes('admin:skyloud')"
      :task="task"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons';
import WaitingButtonsControl from '@/modules/projects/components/TaskControls/WaitingButtonsControl.vue';

defineProps({
  task: {
    type: Object,
    required: true,
  },
});

const store = useStore();
const currentUser = computed(() => store.getters['auth/currentUser']);
</script>
